import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@/components/Icon';
import PlayWalletSelector from '@/components/ui/PlayWalletSelector';
import { GameIcon } from '@/components/casino/mines/MinesArt';
import { Mark } from '@/components/casino/blackjack/BlackjackArt';
import './originals.css';

export function OriginalsIcon({ name, ...props }) {
  return name === 'expand' || name === 'close' ? <Mark name={name} {...props} /> : <GameIcon name={name === 'info' ? 'help' : name} {...props} />;
}

export function OriginalsHeader({ title, icon, subtitle, wallet, balance, children }) {
  const navigate = useNavigate();
  return <><button type="button" className="back-button" onClick={() => navigate('/casino')}><GameIcon name="back" size={14} />Casino</button>
    <div className="game-heading"><div className="heading-title"><span className="heading-icon"><Icon name={icon} size={29} /></span><div><h1>{title}</h1><p>{subtitle || 'PrymeBet Original'}</p></div></div>
      <div className="heading-tools">{balance != null && <div className="wallet"><small>{wallet === 'coins' ? 'PCOINS' : wallet === 'bonus' ? 'BONUS' : 'PCASH'}</small><strong title={String(balance)}>{balance}</strong></div>}{children}</div>
    </div></>;
}

export function OriginalsWallet({ value, onChange, balances, disabled, streamerMode, testidPrefix }) {
  return <fieldset className="wallet-select" disabled={disabled}><PlayWalletSelector value={value} onChange={onChange} {...balances} showBonus={value === 'bonus' || Number(balances?.bonus) > 0} mask={text => streamerMode ? '•••••' : text} caption={false} size="sm" testidPrefix={testidPrefix} /></fieldset>;
}

export function OriginalsStatus({ status, note = 'PrymeBet Original' }) {
  return <div className="game-toolbar below-game"><span role="status" aria-live="polite"><GameIcon name="shield" size={13} />{status}</span><span>{note}</span></div>;
}
